/* eslint-disable no-param-reassign */
import StreamSymbol from 'enums/StreamSymbol'
import MeasurementType, { MeasurementTypeStrings } from 'enums/MeasurementType'
import messageUtil from 'utils/messageUtil'
import { cloneDeep, isEmpty } from 'lodash'
import { Measurement } from 'schemas/MeasurementSchema'
import { ReviewData, defaultReviewData } from 'types/reviewData'
import { Metadata } from './soundbite/adaptor/metadata'

const getHeaderLabel = (type: MeasurementTypeStrings) => messageUtil.measurementType(type)

const addIfNotExist = (contents: Measurement[], measure: Measurement) => {
  const clonedContents = cloneDeep(contents)
  if (!isEmpty(clonedContents)) {
    for (let i = 0; i < clonedContents.length; i += 1) {
      if (clonedContents[i].name === measure.name && clonedContents[i].value === measure.value) {
        clonedContents[i] = measure
        return clonedContents
      }
    }
  }

  clonedContents.push(measure)
  return clonedContents
}

export const addMeasurement = (reviewData: ReviewData[], measure: Measurement) => {
  if (isEmpty(reviewData)) {
    return reviewData
  }

  const label = getHeaderLabel(measure.type!)
  if (label) {
    measure = { ...measure, name: label }
  }

  const clonedReviewData = cloneDeep(reviewData)
  clonedReviewData.forEach((data) => {
    if (
      data.header.type === measure.type &&
      (measure.type === MeasurementType.STAR_OV ||
        measure.type === MeasurementType.SURVEY_OV ||
        measure.type === MeasurementType.NPS)
    ) {
      data.header = measure
    }

    if (
      (data.header.type === MeasurementType.STAR_OV && measure.type === MeasurementType.STAR) ||
      (data.header.type === MeasurementType.SURVEY_OV && measure.type === MeasurementType.SURVEY)
    ) {
      data.contents = addIfNotExist(data.contents, measure)
    }
  })

  return clonedReviewData
}

export const resolveReviewDataFromMetadata = (metadata: Metadata) => {
  let reviewData: ReviewData[] = []
  const dataStreams = metadata.getDataStreams()
  const isInternal = dataStreams && dataStreams[0] === StreamSymbol.VOC
  if (!isInternal) {
    return reviewData
  }

  reviewData.push({
    ...defaultReviewData,
    header: {
      cleanText: '',
      displayText: '',
      highlightedText: '',
      tags: [],
      type: MeasurementType.STAR_OV,
      name: getHeaderLabel(MeasurementType.STAR_OV),
      value: Number(metadata.getOverallStarRating())
    }
  })

  reviewData.push({
    ...defaultReviewData,
    header: {
      cleanText: '',
      displayText: '',
      highlightedText: '',
      tags: [],
      type: MeasurementType.SURVEY_OV,
      name: getHeaderLabel(MeasurementType.SURVEY_OV),
      value: metadata.getOverallSurveyScore()
    }
  })

  reviewData.push({
    ...defaultReviewData,
    header: {
      cleanText: '',
      displayText: '',
      highlightedText: '',
      tags: [],
      type: MeasurementType.NPS,
      name: getHeaderLabel(MeasurementType.NPS),
      value: metadata.getNetPromoterScore()
    }
  })

  const measurements = metadata.getMeasurements()
  if (measurements) {
    measurements.forEach((measurement) => {
      reviewData = addMeasurement(reviewData, measurement)
    })
  }

  return reviewData
}
